"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styles_1 = require("@material-ui/core/styles");

var useStyles = (0, styles_1.makeStyles)(function (theme) {
  return {
    actions: {
      background: theme.palette.text.secondary,
      padding: theme.spacing(2)
    },
    body: {
      background: theme.palette.background.default,
      padding: theme.spacing(10)
    },
    item: {
      margin: '0 auto'
    },
    label: function label(props) {
      return {
        color: props.color.background,
        textDecoration: 'none'
      };
    },
    content: {
      textAlign: 'left',
      wordBreak: 'break-word'
    },
    button: function button(props) {
      return {
        color: props.color.background,
        borderColor: props.color.background,
        margin: 'auto'
      };
    }
  };
});
exports.default = useStyles;